<!-- Expanding a Set mounts this component and fetches its rules, so without this the empty
  "No Rules found." row rendered for the length of the request and was then replaced -- it read
  as a wrong answer rather than as a pending one. -->
@if (isLoading()) {
  <tr class="rules-loading">
    <td colspan="8" class="border-0">
      <div class="d-flex align-items-center justify-content-center py-2">
        <rl-loader text="Loading Rules"></rl-loader>
      </div>
    </td>
  </tr>
} @else {
  <!-- hidden by .no-items-message:not(:last-child) once the rules below it render -->
  <tr class="no-items-message">
    <td colspan="8" class="border-0">
      <div class="d-flex align-items-center justify-content-center py-2">
        <i class="fal fa-table-list"></i>
        <h6 class="mb-0 ms-3">No Rules found.</h6>
      </div>
    </td>
  </tr>
  @for (rule of rules; track rule.groupRuleId) {
    <tr>
      <td colspan="3"></td>
      <rl-account-group-rule class="table-line" [accountGroup]="accountGroup" [rule]="rule"
        [contactPicklistItems]="contactPicklistItems" [amountPicklistItems]="amountPicklistItems"
        [templateItems]="templateItems"
        [templateGroupItems]="templateGroupItems" [hlcCache]="hlcCache"
        (edit)="editRule(rule)" (delete)="deleteRule(rule, deleteRulePrompt)"></rl-account-group-rule>
    </tr>
  }
}

<ng-template #deleteRulePrompt let-prompt="prompt">
  <div>
    <p>
      Are you sure you want to delete this rule?
    </p>
  </div>
  <div class="text-end mt-3 w-100">
    <button class="btn btn-light btn-sm" (click)="prompt.onConfirm.next(false)" data-cy="cancelDeleteTemplate">
      Cancel
    </button>
    <button class="btn btn-success btn-sm ms-2" (click)="prompt.onConfirm.next(true)"
      data-cy="confirmDeleteTemplate">
      Delete Rule
    </button>
  </div>
</ng-template>